import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Info = styled("div")(() => ({
  padding: 16,
  borderRadius: 8,
  background: palette.grey25,
  display: "flex",
  gap: 16,
  justifyContent: "space-between",
}))

export const InfoTitle = styled("div")(() => ({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: "20px",
  marginBottom: 4,
  color: "#031013",
}))

export const InfoText = styled("div")(() => ({
  fontSize: 13,
  lineHeight: "16px",
  color: "#676F71",
}))
